import { useState } from "react";
import { cerifications, certificationsText } from "./constants";
import { ArrowContainer, CertificateDialog, CertificationsContainer, Container, Image, Text } from "./styles";
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
export default function Certifications() {
    const [index, setIndex] = useState('');
    const handleAction = (type) => {
        let res = index;
        if (type === 'Prev') {
            res = index - 1 === 0 ? cerifications.length : index - 1;
        } else {
            res = index + 1 > cerifications.length ? 1 : index + 1;
        }
        setIndex(res);
    };
    return (
        <>
            <Container id="CERTIFICATIONS">
                <Text>{certificationsText}</Text>
                <CertificationsContainer>
                    {cerifications.map((eachCertificate, ind) => {
                        return (
                            <Image src={eachCertificate.src} key={ind} onClick={() => setIndex(ind + 1)} />
                        );
                    })}
                </CertificationsContainer>
            </Container>
            <CertificateDialog open={!!index} onClose={()=>setIndex('')}>
                {cerifications[index - 1] && <div>
                    <ArrowContainer onClick={()=>{handleAction("Prev");}}><ArrowCircleLeftOutlinedIcon /></ArrowContainer>
                    <img src={cerifications[index - 1].src} alt={cerifications[index - 1].name} />
                    <ArrowContainer onClick={()=>{handleAction("Next");}}><ArrowCircleRightOutlinedIcon /></ArrowContainer>
                </div>}
            </CertificateDialog>
        </>
    );
}